<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      {{ titleHero }}
      <div class="title-report-info">
        <h1>{{ subtext.report_info_first }}</h1>
        <h1>{{ subtext.report_info_second }}</h1>
      </div>
      <div class="level-right" slot="right">
        <b-button
          class="is-primary view-report-button"
          @click="routeToReportRun"
          v-if="isEditAllowed"
        >
          <span>View Report</span>
        </b-button>
        <b-button
          class="is-normal view-report-history-button"
          @click="routeToReportHistory"
          v-if="isEditAllowed"
        >
          <span>View History</span>
        </b-button>
      </div>
    </hero-bar>

    <section class="section is-main-section">
      <reporting-tracker-add
        ref="reportingTrackerAdd"
        :is-action="action"
        @updateReportFrequency="updateReportFrequency"
      ></reporting-tracker-add>
    </section>
  </div>
</template>

<script>
import ReportingTrackerAdd from "@/components/Reportingtracker/ReportingTrackerAdd";
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import { UserGroup } from "@/services/UserGroups";
import { mapGetters } from "vuex";
export default {
  name: "ReportingTrackerAddView",
  components: { HeroBar, TitleBar, ReportingTrackerAdd },
  data() {
    return {
      isModalActive: false,
      id: this.$route.params.id,
      url: window.location.href,
      report_frequency: ""
    };
  },
  methods: {
    routeToReportingTracker() {
      this.$router.push({
        name: "reportingtracker",
        query: { id: this.$route.params.id }
      });
    },
    routeToReportRun() {
      this.$refs.reportingTrackerAdd.openReportRun();
    },
    routeToReportHistory() {
      this.$refs.reportingTrackerAdd.openReportHistory();
    },
    updateReportFrequency(reporting_frequency) {
      this.report_frequency = reporting_frequency;
    }
  },
  computed: {
    ...mapGetters(["userGroups"]),
    action() {
      let action;

      if (this.id && this.url.includes("/reportingtracker/edit/")) {
        action = "Edit";
      } else if (this.id && this.url.includes("/reportingtracker/view/")) {
        action = "View";
      } else {
        action = "Add";
      }
      return action;
    },
    subtext() {
      let report_info_first;
      let report_info_second;
      if (this.report_frequency.includes("One-off/other")) {
        report_info_first =
          "In this screen you add One-Off Reports only, e.g. audit reports or retroactive reports. Only one entry in Reporting Tracker will be created. ";
        report_info_second =
          "If you want to add recurring reports, please open respective customer in Customer Profile and add the report there";
      } else {
        report_info_first = "";
        report_info_second = "";
      }
      return { report_info_first, report_info_second };
    },
    titleHero() {
      let subTitle;
      if (this.report_frequency.includes("One-off/other")) {
        if (this.id && this.url.includes("/reportingtracker/edit/")) {
          subTitle = "Edit One-Off Report";
        } else if (this.id && this.url.includes("/reportingtracker/view/")) {
          subTitle = "View One-Off Report";
        } else {
          subTitle = "Add One-Off Report";
        }
      } else {
        if (this.id && this.url.includes("/reportingtracker/edit/")) {
          subTitle = "Edit Report";
        } else if (this.id && this.url.includes("/reportingtracker/view/")) {
          subTitle = "View Report";
        } else {
          subTitle = "Add Report";
        }
      }
      return subTitle;
    },
    titleStack() {
      let lastCrumb;
      if (this.report_frequency.includes("One-off/other")) {
        if (this.id) {
          if (this.action == "View") {
            lastCrumb = "View One-Off Report";
          } else {
            lastCrumb = "Edit One-Off Report";
          }
        } else {
          lastCrumb = "Add One-Off Report";
        }
      } else {
        if (this.id) {
          if (this.action == "View") {
            lastCrumb = "View Report";
          } else {
            lastCrumb = "Edit Report";
          }
        } else {
          lastCrumb = "Add Report";
        }
      }

      return [
        { url: "/reportingtracker", name: "Reporting Tracker" },
        { url: "/reportingtracker/" + lastCrumb, name: lastCrumb }
      ];
    },
    isEditAllowed() {
      if (
        this.userGroups.includes(UserGroup.EPR_ADMIN) ||
        this.userGroups.includes(UserGroup.REPORTING_RESPONSIBLE) ||
        this.userGroups.includes(UserGroup.CUSTOMER_ACCOUNT_MANAGER)
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>
<style scoped>
.title-report-info {
  font-size: 12px;
  color: grey;
  margin-top: 10px;
}
</style>
